import React from 'react';
import T from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import AppIcon from '../../../AppIcon';
import AddToList from '../../../AddToList';
import Button from '../../../Buttons/Button';
import QuickViewCloseButton from '../../QuickViewCloseButton';
import { MARKET_LIST_TYPE } from '../../../AddToList/listTypeConfig';

import { historyPrevItem, handleCleanupRequests } from '../../actions';
import { isDefaultQVSelector, isFinanceQVSelector, permissionsSelector, showBackBtnSelector } from '../../selectors';

const PreHeader = ({ app, onClose }) => {
  const dispatch = useDispatch();

  const isShowBackBtn = useSelector(showBackBtnSelector);
  const permissions = useSelector(permissionsSelector);
  const isFinanceQV = useSelector(isFinanceQVSelector);
  const isDefaultQV = useSelector(isDefaultQVSelector);

  const appPageLink = `${window.location.origin}/apps/${app.store}/${app.ref_no}/${permissions.defaultQuickViewPageName || 'performance'}`;

  const handleBack = () => dispatch(historyPrevItem());

  return (
    <div className="app-quick-view__preheader">
      {isDefaultQV && (
        <div className="app-quick-view__preheader-btns">
          {isShowBackBtn && (
            <Button
              shape="square"
              variant="secondary"
              className="back-btn"
              onClick={handleBack}
            >
              <span className="hicon-angle-down-alt" />
            </Button>
          )}
          <Button
            variant="primary"
            href={appPageLink}
            onClick={handleCleanupRequests}
          >
            Go to App
          </Button>
          <QuickViewCloseButton
            onClose={onClose}
          />
        </div>
      )}
      <div className="app-quick-view__header-min-box">
        <div className="app-quick-view__header-min">
          <div className="app-quick-view__header-min-text">
            <div className="app-quick-view__header-min-text-head text-truncate">
              <AppIcon
                url={app.icon_url}
                store={app.store}
                size={24}
                alt={app.name}
                withBorder
              />
              <span className="text-truncate">{app.name}</span>
            </div>
            {isDefaultQV && (
              <div className="app-quick-view__header-min-btn">
                <AddToList
                  entities={[{ ...app }]}
                  className="add-to-market-widget"
                  listType={MARKET_LIST_TYPE}
                      // currentUserId={permissions.current_user_id}
                      // customerId={permissions.customer_id}
                  ignoreCustomEvents
                  variant="secondary"
                  buttonSize="sm"
                  icon="hicon-plus-circle-thin"
                />
              </div>
            )}
            {isFinanceQV && (
              <div className="app-quick-view__header-min-text-actions">
                <Button
                  size="sm"
                  href={appPageLink}
                  onClick={handleCleanupRequests}
                >
                  View App
                </Button>
                <QuickViewCloseButton
                  size="sm"
                  onClose={onClose}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

PreHeader.propTypes = {
  app: T.object.isRequired,
  onClose: T.func.isRequired,
};

export default PreHeader;
